<!-- MTKのBookGroup毎の情報を表示するカード -->
<!-- storeの値を呼び出しているので単体テスト不可。一旦stortbookなし -->
<template>
  <!-- is_usedがtrueなら非表示 -->
  <div class="masterbook_division radio">
    <!-- ラジオボタン クリックされると親コンポーネントへ情報を引き渡す -->
    <input
      :id="'radio-' + index"
      name="radio"
      type="radio"
      v-model="radio"
      :value="{
        type: bookgroup._qrcode_mtk_type,
        bookgroup: bookgroup,
        id: targetTicket.id,
        master_id: targetTicket.master_id,
      }"
      v-on:change="onChange"
    />

    <!-- ラベル -->
    <label :for="'radio-' + index" class="radio-label"> </label>

    <!--期間のケツを-1日-->
    <p class="right-text">
      {{ bookgroup.books[0].name }}<br />
      {{ targetTicket.name }}<br />
      {{ targetTicket.label }}<br />
      {{ displayDate(targetTicket.start) }} ~
      {{ displayDateMinus1D(targetTicket.limit) }}
    </p>
  </div>
</template>

<script>
import MTKMixin from "@/mixins/SetQR/MTKMixin";

export default {
  name: "MTKBookGroupCard",
  mixins: [MTKMixin],
  data() {
    return {
      radio: null,
    };
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    bookgroup: {
      type: Object,
      required: true,
    },
    targetTicket: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onChange() {
      this.$emit("grandChildMethod", this.radio);
    },
  },
};
</script>

<style lang="scss" scoped>
.masterbook_division {
  border-bottom: 1px solid #e0e0e0;
}
.radio-select {
  display: block;
  margin: 1rem;
  font-size: 1.3rem;
}

$color1: #f4f4f4;
$color2: #fdc138;
.radio-area {
  margin: 15px;
}

.right-text {
  padding-left: 40px;
  font-size: 0.7rem;
}

.radio {
  padding: 1rem;
  input[type="radio"] {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 50px;
    + .radio-label {
      float: left;
      &:before {
        content: "";
        background: $color1;
        border-radius: 100%;
        border: 1px solid darken($color1, 25%);
        display: inline-block;
        width: 1.5em;
        height: 1.5em;
        position: relative;
        top: -0.2em;
        margin-right: 1em;
        vertical-align: top;
        cursor: pointer;
        text-align: center;
        transition: all 250ms ease;
      }
    }
    &:checked {
      + .radio-label {
        &:before {
          background-color: $color2;
          box-shadow: inset 0 0 0 4px $color1;
        }
      }
    }
    &:focus {
      + .radio-label {
        &:before {
          outline: none;
          border-color: $color2;
        }
      }
    }
    &:disabled {
      + .radio-label {
        &:before {
          box-shadow: inset 0 0 0 4px $color1;
          border-color: darken($color1, 25%);
          background: darken($color1, 25%);
        }
      }
    }
    + .radio-label {
      &:empty {
        &:before {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
